import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createNamespace, isStringElement } from '@swagger-api/apidom-core';
import * as jsonSchemaDraft4Predicates from "../predicates.js";
import jsonSchemaDraft4Namespace from "../namespace.js";
const createToolbox = () => {
  const namespace = createNamespace(jsonSchemaDraft4Namespace);
  const predicates = _objectSpread(_objectSpread({}, jsonSchemaDraft4Predicates), {}, {
    isStringElement
  });
  return {
    predicates,
    namespace
  };
};
export default createToolbox;